(function () {
  var INJECTED_CSS = [
    /* ===== Visual styles (apply on ALL viewports) ===== */
    '.cart-footer {',
    '  border: 1px solid #000 !important; border-radius: 10px !important;',
    '  background: #fafafa !important; padding: 20px 22px !important;',
    '}',
    '.cart-footer .block-section { padding-top: 0 !important; padding-bottom: 0 !important; }',
    '.cart-free-shipping-note { color: #1a8a3a !important; font-weight: 600 !important; }',

    /* Stack dynamic checkout buttons vertically — all viewports */
    '.cart-dynamic-checkout-buttons, .additional-checkout-buttons {',
    '  display: flex !important; flex-direction: column !important; gap: 8px !important;',
    '  width: 100% !important; margin-top: 12px !important;',
    '}',
    'shopify-accelerated-checkout-cart { display: block !important; width: 100% !important; }',
    'shopify-accelerated-checkout-cart .wallet-button-wrapper,',
    '.dynamic-checkout__content .wallet-button-wrapper { width: 100% !important; display: block !important; }',
    'shopify-accelerated-checkout-cart .wallet-cart-grid,',
    '.dynamic-checkout__content .wallet-cart-grid,',
    'ul.wallet-cart-grid {',
    '  display: flex !important; flex-direction: column !important;',
    '  grid-template-columns: 1fr !important; gap: 8px !important;',
    '  width: 100% !important; margin: 0 !important; padding: 0 !important; list-style: none !important;',
    '}',
    'shopify-accelerated-checkout-cart .wallet-cart-button-container,',
    '.dynamic-checkout__content .wallet-cart-button-container,',
    'li.wallet-cart-button-container {',
    '  width: 100% !important; max-width: 100% !important; display: block !important;',
    '  list-style: none !important; margin: 0 !important; padding: 0 !important;',
    '}',
    'shopify-accelerated-checkout-cart .wallet-cart-button,',
    '.dynamic-checkout__content .wallet-cart-button {',
    '  width: 100% !important; max-width: 100% !important; min-width: 0 !important; display: block !important;',
    '}',

    /* Title row: cart heading + top checkout button — all viewports */
    '.page-title-wrap {',
    '  display: flex !important; align-items: center !important; justify-content: space-between !important;',
    '  flex-wrap: wrap !important; gap: 1rem !important;',
    '}',
    '.squarecable-cart-top-checkout {',
    '  display: inline-flex !important; align-items: center !important; justify-content: center !important;',
    '  padding: 12px 28px !important; background: #003a8c !important; color: #fff !important;',
    '  font-weight: 600 !important; font-size: 15px !important; border-radius: 999px !important;',
    '  text-decoration: none !important; border: none !important; cursor: pointer !important;',
    '}',
    '.squarecable-cart-top-checkout:hover, .squarecable-cart-top-checkout:focus {',
    '  background: #002766 !important; color: #fff !important;',
    '}',

    /* ===== Desktop layout (>=990px): box on the right, under QUANTITY ===== */
    '@media (min-width: 990px) {',
    '  #MainContent { display: block !important; grid-template-columns: none !important; }',
    '  #main-cart-footer.container {',
    '    max-width: 420px !important; margin-left: auto !important;',
    '    padding-top: 0 !important; padding-bottom: 0 !important;',
    '  }',
    '  [id*="__cart-items"] { padding-bottom: 0 !important; margin-bottom: 0 !important; }',
    '  [id*="__cart-footer"] { padding-top: 0 !important; margin-top: -8px !important; }',
    '  .cart-footer { position: static !important; margin-top: 0 !important; }',
    '}',

    /* ===== Tablet (750-989px): box full-width, centered, breathing room ===== */
    '@media (min-width: 750px) and (max-width: 989px) {',
    '  #main-cart-footer.container {',
    '    max-width: 100% !important; margin-left: 0 !important; margin-right: 0 !important;',
    '  }',
    '  .cart-footer { margin-top: 16px !important; }',
    '}',

    /* ===== Mobile (<750px): tighter padding, smaller top checkout button ===== */
    '@media (max-width: 749px) {',
    '  #main-cart-footer.container {',
    '    max-width: 100% !important; margin-left: 0 !important; margin-right: 0 !important;',
    '    padding-left: 0 !important; padding-right: 0 !important;',
    '  }',
    '  .cart-footer { margin-top: 12px !important; padding: 16px !important; }',
    '  .squarecable-cart-top-checkout { padding: 10px 22px !important; font-size: 14px !important; }',
    '  .page-title-wrap { gap: 0.5rem !important; }',
    '}'
  ].join('\n');

  function injectCSS() {
    if (document.getElementById('squarecable-cart-inline-css')) return;
    var style = document.createElement('style');
    style.id = 'squarecable-cart-inline-css';
    style.textContent = INJECTED_CSS;
    document.head.appendChild(style);
  }

  function isCartEmpty() {
    // Shopify's Liquid adds the "is-empty" class to <cart-items> when the cart
    // has no items, and disables the bottom #checkout button. We treat any of
    // these signals as "empty" so the top button is not shown for empty carts.
    var cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.classList.contains('is-empty')) return true;
    var bottomBtn = document.querySelector('#checkout');
    if (!bottomBtn || bottomBtn.disabled) return true;
    return false;
  }

  function injectTopCheckoutButton() {
    var titleWrap = document.querySelector('#cart-page-title-wrap .page-title-wrap');
    if (!titleWrap) return;

    var existing = titleWrap.querySelector('.squarecable-cart-top-checkout');

    // If the cart is empty, remove any leftover top button and bail out.
    if (isCartEmpty()) {
      if (existing) existing.remove();
      return;
    }

    if (existing) return; // already injected, nothing to do

    var checkoutBtn = document.querySelector('#checkout');
    if (!checkoutBtn) return;

    var topBtn = document.createElement('button');
    topBtn.setAttribute('type', 'submit');
    topBtn.setAttribute('name', 'checkout');
    // HTMLButtonElement.form is READ-ONLY in the DOM, so we must use
    // setAttribute to associate the button with the <form id="cart">.
    topBtn.setAttribute('form', 'cart');
    topBtn.className = 'squarecable-cart-top-checkout';
    topBtn.textContent = checkoutBtn.textContent.trim();
    topBtn.setAttribute('aria-label', topBtn.textContent);
    titleWrap.appendChild(topBtn);
  }

  function alignSummaryUnderQuantity() {
    var footer = document.querySelector('#main-cart-footer.container');
    if (!footer) return;

    if (window.innerWidth < 990) {
      footer.style.marginRight = '';
      return;
    }

    var headers = document.querySelectorAll('.cart-items thead th');
    var totalCol = null;
    for (var i = headers.length - 1; i >= 0; i--) {
      if (headers[i].offsetParent !== null) {
        totalCol = headers[i];
        break;
      }
    }
    if (!totalCol) return;

    var parent = footer.parentElement || document.body;
    var parentRect = parent.getBoundingClientRect();
    var totalRect = totalCol.getBoundingClientRect();

    // Tweak: shift the box ~40px to the right so it visually sits under QUANTITY
    var TWEAK_PX = 40;
    var rightOffset = Math.max(0, parentRect.right - totalRect.left - TWEAK_PX);
    footer.style.marginRight = rightOffset + 'px';
  }

  function forceWalletGridStack() {
    var grids = document.querySelectorAll(
      'shopify-accelerated-checkout-cart .wallet-cart-grid, ' +
      '.dynamic-checkout__content .wallet-cart-grid, ' +
      'ul.wallet-cart-grid'
    );
    grids.forEach(function (grid) {
      grid.style.setProperty('display', 'flex', 'important');
      grid.style.setProperty('flex-direction', 'column', 'important');
      grid.style.setProperty('grid-template-columns', '1fr', 'important');
      grid.style.setProperty('gap', '8px', 'important');
      grid.style.setProperty('width', '100%', 'important');
    });
    var cells = document.querySelectorAll('.wallet-cart-button-container');
    cells.forEach(function (cell) {
      cell.style.setProperty('width', '100%', 'important');
      cell.style.setProperty('display', 'block', 'important');
    });
    var buttons = document.querySelectorAll('.wallet-cart-button');
    buttons.forEach(function (btn) {
      btn.style.setProperty('width', '100%', 'important');
      btn.style.setProperty('max-width', '100%', 'important');
    });
  }

  function watchForCartChanges() {
    // Permanent observer: on every DOM mutation under <body>, re-run all our
    // injections. Shopify replaces #cart-page-title-wrap and the cart-items
    // section via AJAX when the user removes an item or changes quantity,
    // which wipes out our injected top checkout button.
    var observer = new MutationObserver(function () {
      forceWalletGridStack();
      injectTopCheckoutButton();
      alignSummaryUnderQuantity();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Safety net: re-apply every 500ms for the first 10 seconds in case the
    // observer misses something during the initial Shopify hydration.
    var attempts = 0;
    var interval = setInterval(function () {
      forceWalletGridStack();
      injectTopCheckoutButton();
      if (++attempts >= 20) clearInterval(interval);
    }, 500);
  }

  function init() {
    injectCSS();
    injectTopCheckoutButton();
    forceWalletGridStack();
    watchForCartChanges();
    alignSummaryUnderQuantity();
    window.addEventListener('resize', alignSummaryUnderQuantity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
